"use client";
import React, { useEffect } from "react";
import DefaultEmbedIcon from "./DefaultEmbedIcon";
import { useInterfacesTheme } from "lib/theme/ThemeProvider";
import { cn } from "utils/cn";

export default function ErrorEmbedIcon(
  props: React.ComponentProps<typeof DefaultEmbedIcon>
) {
  const interfacesTheme = useInterfacesTheme();
  // we'll just add a data-error attribute to the DefaultEmbedIcon
  // alongside some additional classes to style it...
  // if we wanted to have a completely different representation,
  // we can replace the DefaultEmbedIcon with a custom component

  useEffect(() => {
    window.parent.postMessage("zChatbotReady", "*");
  }, []);

  return (
    <DefaultEmbedIcon
      {...props}
      data-error="true"
      className={cn(
        "data-[error]:opacity-75",
        {
          "data-[error]:bg-zi-danger": !interfacesTheme,
          "data-[error]:bg-destructive": interfacesTheme,
        },
        props.className
      )}
    />
  );
}
